<div
  class="starman-icon starman-icon--{{ category }}-{{ name }}"
  [ngClass]="{ 'starman-icon--inverted': invert }"
  [ngStyle]="customStyle"
></div>
